import './App.css';
import { Toaster } from 'sonner';
import { Routes, Route, Link, Navigate } from "react-router-dom";
import {react, useState, useEffect} from 'react';
import {light, dark, highContrast} from './functions/theme/themes.js';
import GlobalContext from './context/GlobalContext.js'
import Home from './pages/home.js';
import Login from './pages/login.js';
import R404 from './pages/R404.js';
import Register from './pages/register.js';
import RequestResetPassword from './pages/requestresetpasssword.js';
import ResetPassword from './pages/resetpassword.js';
import Repairs from './pages/repairs.js';
import Transactions from './pages/transactions.js'
import Requests from './pages/requests.js'
import Payment from './pages/payment.js'
import AllPayMobileAppDirectDebit from './pages/AllPayMobileAppDirectDebit';
import AllPayDDResult from './pages/allpayddresult';
import Profile from './pages/profile.js'
import Admin from './pages/admin.js'
import AdminUsers from './pages/adminusers.js'
import Customers from './pages/customers.js'
import Settings from './pages/settings.js'
import AdvancedSettings from './pages/advancedsettings.js'
import IntegrationManager from './pages/IntegrationManager.js'
import Categories from './pages/categories.js'
import RequestTypes from './pages/requesttypes.js'
import TaskFlows from './pages/taskflows.js'
import TaskFlowDetail from './pages/taskflowDetail.js'
import TaskInstances from './pages/taskInstances.js'
import TaskInstanceDetail from './pages/taskInstanceDetail.js'
import Feedback from './pages/feedback.js'
import RepairDefinition from './pages/repairdefinitions.js'
import RepairGroups from './pages/repairgroups.js'
import ExtendedVerification from './pages/extendedverification';
import Appointments from './pages/appointments';
import Documents from './pages/documents';
import Messages from './pages/messages';
import ContactMethodMappings from './pages/contactmethodmappings';
import Reports from './pages/reports.js'
import MessageCenter from './pages/messagecenter';
import TestSystemBanner from './components/testsystembanner';
import getAPI from './functions/API/getAPI';
import Loader from './components/loader.js'
import CredentialManager from './pages/credentialManager.js';
import AdobeSignCallback from './pages/AdobeSignCallback.js';
import EntraCallback from './pages/EntraCallback.js';
import SsoCallback from './pages/SsoCallback.js';
import SsoSettings from './pages/SsoSettings.js';
import OnboardingAccept from './pages/onboardingAccept.js';
import OnboardingTaskList from './pages/OnboardingTaskList.js';
import OnboardingStepDetail from './pages/OnboardingStepDetail.js';
import OnboardingPaymentResult from './pages/OnboardingPaymentResult.js';
import TenantLayout from './components/TenantLayout.js';

export default function App() {

  const [loading, isLoading] = useState(true);
  const [runWalkthrough, setRunWalkthrough] = useState(false);

  //Set theme state and persist selection between session
  const [theme, setTheme] = useState(() => {
    let SelectedTheme = localStorage.getItem('theme');
    if(SelectedTheme && SelectedTheme !== 'dark'){
      return SelectedTheme
    } else {
      localStorage.setItem('theme', 'light');
      return 'light'
    }
  });

  // Font size scaling — persisted to localStorage
  const [fontSize, setFontSize] = useState(() => {
    return localStorage.getItem('fontSize') || 'large';
  });

  function updateFontSize(size) {
    setFontSize(size);
    localStorage.setItem('fontSize', size);
  }

  // Apply font size class to document root
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('font-size-normal', 'font-size-large', 'font-size-xl');
    root.classList.add(`font-size-${fontSize}`);
  }, [fontSize]);

  const [settings, setSettings] = useState(
    async function () {
      if (localStorage.getItem("apiToken")) {
        const PublicSettingsResponse = await getAPI('settings');
        setSettings(PublicSettingsResponse.data)
        document.title = PublicSettingsResponse.data.company_name
      } else {
        const PublicSettingsResponse = await getAPI('settings',true);
        setSettings(PublicSettingsResponse.data)
        document.title = PublicSettingsResponse.data.company_name
      }
      isLoading(false)
    }
  );

  const [publicSettings, setPublicSettings] = useState(
    async function () {
      const PublicSettingsResponse = await getAPI('settings',true);
        setPublicSettings(PublicSettingsResponse.data)
    }
  );

  

  //Set themeCSS state and use theme
  const [themeCSS, setThemeCSS] = useState(() => {
    if(theme === 'highContrast'){
        return highContrast
    }
    return light
  })

  function updateTheme(selectedtheme){
    setTheme(selectedtheme)
    localStorage.setItem('theme', selectedtheme);
    if(selectedtheme === 'highContrast'){
      setThemeCSS(highContrast)
    } else {
      setThemeCSS(light)
    }
  }
  
  function RequireAuth({ children, redirectTo }) {
    let apiToken = localStorage.getItem("apiToken");
    let role = localStorage.getItem("role");
    if(role == "admin") return <Navigate to="/admin" />
    if(role == "pre_tenancy") return <Navigate to="/onboarding" />
    return apiToken ? children : <Navigate to={redirectTo} />;
  }

  function PreTenancyRoute({ children }) {
    let apiToken = localStorage.getItem("apiToken");
    let role = localStorage.getItem("role");
    if (!apiToken) return <Navigate to="/login" />;
    if (role !== "pre_tenancy") return <Navigate to="/home" />;
    return children;
  }

  function LoggedInRedirect({ children, redirectTo }) {
    let apiToken = localStorage.getItem("apiToken");
    return apiToken ? <Navigate to={redirectTo} /> : children;
  }

  function AdminRoute({ children, redirectTo }) {
    let role = localStorage.getItem("role");
    return role == 'admin' ?  children : <Navigate to={redirectTo} />;
  }


  return (
    <>
    {/* {publicSettings.company_name} */}
      {loading ?
        <div className="App">
            {/* <Loader width="100%" height="100%" backgroundColor={(theme === "dark"? "#1e293a":"#eee")}/> */}
        </div>
      :
      settings && (
        <div>
          <Toaster position="bottom-center" richColors closeButton duration={2000} />
          <GlobalContext.Provider value={{theme, updateTheme, themeCSS, settings, publicSettings, runWalkthrough, setRunWalkthrough, fontSize, updateFontSize}} >
            <Routes>

              <Route element={
                <RequireAuth redirectTo="/login">
                  <TenantLayout />
                </RequireAuth>
              }>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/extendedverification" element={<ExtendedVerification />} />
                {settings.repairs_enabled === 1 && (
                  <Route path="/repairs" element={<Repairs />} />
                )}
                {settings.repairs_enabled === 1 && (
                  <Route path="/appointments" element={<Appointments />} />
                )}
                {settings.document_management_enabled === 1 && (
                  <Route path="/documents/:id" element={<Documents />} />
                )}
                {settings.transactions_enabled === 1 && (
                  <Route path="/transactions" element={<Transactions />} />
                )}
                {settings.requests_enabled === 1 && (
                  <Route path="/requests" element={<Requests />} />
                )}
                <Route path="/messages" element={<Messages />} />
              </Route>

              <Route path="/login" element={
                <LoggedInRedirect redirectTo="/home">
                  <Login />
                </LoggedInRedirect>
              }/>

              {settings.registration_enabled && (
                <Route path="/register" element={
                <LoggedInRedirect redirectTo="/home">
                  <Register />
                </LoggedInRedirect>
              }/>
              )}
              

              <Route path="/request-password-reset" element={
                <LoggedInRedirect redirectTo="/home">
                  <RequestResetPassword />
                </LoggedInRedirect>
              }/>

              <Route path="/reset-password/:token" element={
                <LoggedInRedirect redirectTo="/home">
                  <ResetPassword />
                </LoggedInRedirect>
              }/>

              <Route path="/admin" element={
                <AdminRoute redirectTo="/home">
                  <Admin />
                </AdminRoute>
              }/>

              <Route path="/adminusers" element={
                <AdminRoute redirectTo="/home">
                  <AdminUsers />
                </AdminRoute>
              }/>

              <Route path="/customers" element={
                <AdminRoute redirectTo="/home">
                  <Customers />
                </AdminRoute>
              }/>

              <Route path="/requesttypes" element={
                <AdminRoute redirectTo="/home">
                  <RequestTypes />
                </AdminRoute>
              }/>

              <Route path="/taskflows" element={
                <AdminRoute redirectTo="/home">
                  <TaskFlows />
                </AdminRoute>
              }/>

              <Route path="/taskflows/:id" element={
                <AdminRoute redirectTo="/home">
                  <TaskFlowDetail />
                </AdminRoute>
              }/>

              <Route path="/taskinstances" element={
                <AdminRoute redirectTo="/home">
                  <TaskInstances />
                </AdminRoute>
              }/>

              <Route path="/taskinstances/:id" element={
                <AdminRoute redirectTo="/home">
                  <TaskInstanceDetail />
                </AdminRoute>
              }/>

              <Route path="/feedback" element={
                <AdminRoute redirectTo="/home">
                  <Feedback />
                </AdminRoute>
              }/>

              <Route path="/categories" element={
                <AdminRoute redirectTo="/home">
                  <Categories />
                </AdminRoute>
              }/>

              <Route path="/repairdefinitions" element={
                <AdminRoute redirectTo="/home">
                  <RepairDefinition />
                </AdminRoute>
              }/>

              <Route path="/integration-manager" element={
                <AdminRoute redirectTo="/home">
                  <IntegrationManager />
                </AdminRoute>
              }/>

              <Route path="/settings" element={
                <AdminRoute redirectTo="/home">
                  <Settings />
                </AdminRoute>
              }/>

              <Route path="/advancedsettings" element={
                <AdminRoute redirectTo="/home">
                  <AdvancedSettings />
                </AdminRoute>
              }/>

              <Route path="/contactmethods" element={
                <AdminRoute redirectTo="/home">
                  <ContactMethodMappings />
                </AdminRoute>
              }/>

              <Route path="/repair-groups" element={
                <AdminRoute redirectTo="/home">
                  <RepairGroups />
                </AdminRoute>
              }/>

              <Route path="/reports" element={
                <AdminRoute redirectTo="/home">
                  <Reports />
                </AdminRoute>
              }/>

              <Route path="/message-center" element={
                <AdminRoute redirectTo="/home">
                  <MessageCenter />
                </AdminRoute>
              }/>

              <Route path="/credential-manager" element={
                <AdminRoute redirectTo="/home">
                  <CredentialManager />
                </AdminRoute>
              }/>

              <Route path="/integrations/adobesign/callback" element={
                <AdobeSignCallback />
              }/>

              <Route path="/integrations/entra/callback" element={
                <EntraCallback />
              }/>

              <Route path="/sso/callback" element={
                <SsoCallback />
              }/>

              <Route path="/sso-settings" element={
                <AdminRoute redirectTo="/home">
                  <SsoSettings />
                </AdminRoute>
              }/>

              <Route path="/onboarding/accept/:token" element={
                <OnboardingAccept />
              }/>

              <Route path="/onboarding" element={
                <PreTenancyRoute>
                  <OnboardingTaskList />
                </PreTenancyRoute>
              }/>

              <Route path="/onboarding/step/:stepId" element={
                <PreTenancyRoute>
                  <OnboardingStepDetail />
                </PreTenancyRoute>
              }/>

              <Route path="/onboarding/payment-result" element={
                <PreTenancyRoute>
                  <OnboardingPaymentResult />
                </PreTenancyRoute>
              }/>

              <Route path="/allpaypayment/:accountreference/:token/:gatewayurl/:clientcode/:source" element={
                  <Payment />
              }/>

              <Route path="/allpaydirectdebit/create" element={
                  <AllPayMobileAppDirectDebit />
              }/>

              <Route path="/allpayddresult/:result" exact element={    
                  <AllPayDDResult />
              }/>
              
              {!isLoading && <Route path="*" element={<R404 />} />}
              
            </Routes>
          </GlobalContext.Provider >
        </div>
      )}
    
    </>
);

}
